/**
 * @generated SignedSource<<3042b304e21dae8d9d2bf8c6a2314c54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionJuryUserAutocompleteQuery$variables = Record<PropertyKey, never>;
export type CompetitionJuryUserAutocompleteQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserAutocompleteFragment">;
};
export type CompetitionJuryUserAutocompleteQuery = {
  response: CompetitionJuryUserAutocompleteQuery$data;
  variables: CompetitionJuryUserAutocompleteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "Literal",
  "name": "kinds",
  "value": [
    "USER"
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionJuryUserAutocompleteQuery",
    "selections": [
      {
        "args": [
          (v0/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "UserAutocompleteFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CompetitionJuryUserAutocompleteQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 10
          },
          (v0/*: any*/)
        ],
        "concreteType": "EntityConnection",
        "kind": "LinkedField",
        "name": "entities",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kind",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "entities(first:10,kinds:[\"USER\"])"
      }
    ]
  },
  "params": {
    "cacheID": "f64aa789c297c297866fcf53722d5a16",
    "id": null,
    "metadata": {},
    "name": "CompetitionJuryUserAutocompleteQuery",
    "operationKind": "query",
    "text": "query CompetitionJuryUserAutocompleteQuery {\n  ...UserAutocompleteFragment_4ddT5H\n}\n\nfragment UserAutocompleteFragment_4ddT5H on Query {\n  entities(first: 10, kinds: [USER]) {\n    edges {\n      node {\n        __typename\n        id\n        kind\n        username\n        displayName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3aadfd813c3cf82602bfc9409ea3950";

export default node;
